export const N = {
    init: () => {
        const newsletterForm = document.querySelector(".js-newsletter-form");
        const status = document.querySelector(".js-newsletter-form-status");

        if (newsletterForm) {
            newsletterForm.addEventListener("submit", async (e) => {
                e.preventDefault();

                status.classList.add("d-none");
                status.classList.remove("alert-success", "alert-danger");
                status.textContent = "";

                const submitBtn = newsletterForm.querySelector('button[type="submit"]');
                submitBtn?.setAttribute("disabled", "disabled");

                try {
                    const formData = new FormData(newsletterForm);
                    const response = await fetch("/Umbraco/Api/NewsletterApi/Subscribe", {
                        method: "POST",
                        body: formData
                    });

                    if (!response.ok) {
                        throw new Error(response.status);
                    }

                    const result = await response.json();

                    if (result.success)
                        status.classList.add('alert-success');
                    else
                        status.classList.add('alert-danger');

                    status.textContent = result.message;

                } catch (err) {
                    status.classList.add('alert-danger');
                    status.textContent = err;
                } finally {
                    status.classList.remove('d-none');
                    submitBtn?.removeAttribute("disabled");
                }
            });
        }
    }
}
